// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__cewju","faceapiSection":"app_faceapiSection__2-e2I"};